import { createTheme } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { defaultTheme } from 'react-admin';

export const adminTheme = createTheme(
  deepmerge(defaultTheme, {
    components: {
      MuiTab: {
        styleOverrides: {
          root: {
            flex: '1 1 auto',
            // Adjust this value as needed
            width: '120px',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          flexContainer: {
            flexWrap: 'wrap',
          },
        },
      },
    },
  }),
);
